import { render } from "./latestProducts.vue?vue&type=template&id=5c5e0fbc&scoped=true"
import script from "./latestProducts.vue?vue&type=script&lang=js"
export * from "./latestProducts.vue?vue&type=script&lang=js"

import "./latestProducts.vue?vue&type=style&index=0&id=5c5e0fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5e0fbc"]])

export default __exports__